export default __webpack_public_path__ + "static/media/25 Track 25.ad14a08f.mp3";